// frontend/src/api/CNASTDERDAFileApi.js (ejemplo)

import api from "./api";
// import { normalizePayload } from "../utils/normalizePayload";

// Obtener todos los archivos
export const fetchCNASTDERDAFiles = async () => {
  try {
    const response = await api.get("/cna-std-erda-files/");
    return response.data;
  } catch (error) {
    console.error("Error fetching CNA STD ERDA file records:", error);
    throw error;
  }
};

// Obtener un archivo por ID
export const fetchCNASTDERDAFileById = async (id) => {
  try {
    const response = await api.get(`/cna-std-erda-files/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching CNA STD ERDA file with ID ${id}:`, error);
    throw error;
  }
};

// Obtener archivos de propuesta
export const listCNASTDERDAFilesByProposal = async (proposalId) => {
  const response = await api.get(`/cna-std-erda-files/proposal/${proposalId}/`);
  return response.data;
};

// Buscar archivos por nombre (contiene)
export const searchCNASTDERDAFiles = async (query) => {
  try {
    const response = await api.get(
      `/cna-std-erda-files/?search=${encodeURIComponent(query)}`,
    );
    return response.data;
  } catch (error) {
    console.error(
      `Error searching CNA STD ERDA files with query "${query}":`,
      error,
    );
    throw error;
  }
};

export const createCNASTDERDAFile = async (data) => {
  try {
    const response = await api.post("/cna-std-erda-files/", data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error creating CNA STD ERDA file:",
      error.response?.data || error,
    );
    throw error;
  }
};

// Actualizar un archivo (solo si es del usuario)
export const updateCNASTDERDAFile = async (id, data) => {
  try {
    // const payload = normalizePayload(data);
    const response = await api.patch(`/cna-std-erda-files/${id}/`, data);
    return response.data;
  } catch (error) {
    console.error(`Error updating CNA STD ERDA file with ID ${id}:`, error);
    console.log("STATUS:", error.response?.status);
    console.log("DATA:", error.response?.data);
    console.log("HEADERS:", error.response?.headers);
    throw error;
  }
};

// Eliminar un archivo (solo si es del usuario)
export const softDeleteCNASTDERDAFile = async (id) => {
  try {
    const response = await api.delete(`/cna-std-erda-files/${id}/`);
    return response.data;
  } catch (error) {
    console.error("Error soft-deleting CNA STD ERDA files:", error);
    throw error;
  }
};

// Exportar archivos por ID
export const exportCNASTDERDAFilesById = async (idsArray) => {
  try {
    const idsParam = idsArray.join(",");
    const response = await api.get(
      `/cna-std-erda-files/export/?ids=${idsParam}`,
      {
        responseType: "blob",
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error exporting CNA STD ERDA files by ID:", error);
    throw error;
  }
};

// Filtros generales
export const filterCNASTDERDAFiles = async (params) => {
  try {
    const query = new URLSearchParams(params).toString();
    const response = await api.get(`/cna-std-erda-files/?${query}`);
    return response.data;
  } catch (error) {
    console.error("Error filtering  CNA STD ERDA files:", error);
    throw error;
  }
};
